@if (value() > 0) {
  <span class=" -ml-3 text-[10px] py-0.5 bg-red-500 text-white rounded-full px-1 leading-4 absolute" style="line-height: 1">{{ value() }}</span>
}
